module.exports = __webpack_public_path__ + "img/icon-call-light.f16a757b.svg";